import type { ReactNode } from 'react';

export interface TabItem {
  key: string;
  label: ReactNode;
  badge?: number | string;
}

export interface TabsProps {
  items: TabItem[];
  value: string;
  onChange: (key: string) => void;
  className?: string;
  'aria-label'?: string;
}

/** Tabs — 큐 필터/섹션 전환. 게임화 period 탭과 동일 시각 언어. */
export function Tabs({ items, value, onChange, className, ...rest }: TabsProps) {
  return (
    <div
      className={['bq-tabs', className ?? ''].filter(Boolean).join(' ')}
      role="tablist"
      aria-label={rest['aria-label']}
    >
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          role="tab"
          aria-selected={value === it.key}
          className={`bq-tab${value === it.key ? ' is-active' : ''}`}
          onClick={() => onChange(it.key)}
        >
          {it.label}
          {it.badge != null && it.badge !== '' && (
            <span className="bq-tab__badge">{it.badge}</span>
          )}
        </button>
      ))}
    </div>
  );
}
